<template>
    <div>
        <!--&lt;!&ndash;侧边栏&ndash;&gt;-->
        <!--<SideBarCmp :clientH="clientH" :isToggle="isToggleSideBar"/>-->
        <!--&lt;!&ndash;头部header&ndash;&gt;-->
        <!--<HeaderCmp @toggleSideBar="toggleSideBar"/>-->
        <!--&lt;!&ndash;路由模块&ndash;&gt;-->
        <!--<router-view-->
        <!--:homeData="totalData"-->
        <!--:clientH="clientH"-->
        <!--:class="{ marginL50: isToggleSideBar, 'content-container': !isToggleSideBar }"-->
        <!--&gt;-->
        <!--</router-view>-->
        <!--<MainCmp v-if="isLogin"/>-->
        <!--<Login v-else/>-->
        <router-view :clientH="clientH"></router-view>
    </div>
</template>
<style>

</style>
<script>
  import MainCmp from "./components/MainCmp.vue";
  import "./utils/DateFormat.js";

  export default {
    data: function () {
      return {
        /*clientH: 0,//动态屏幕可见区域高度*/
        isToggleSideBar: false//侧边栏是否切换成小的
      }
    },
    created: function () {
      /*let _this = this;
      this.$router.push("/main");
      if (_this.isLogin) {//如果已经登录则重新获取用户信息
        this.$router.push("/main")
         if(location.hash.indexOf("linkCx")>0){
             this.$router.push("/linkCx");
         }else this.$router.push("/main");*!/
      } else {//如果未登录则跳转到登录页面
        this.$router.push("/login")
        //
      }*/
      /*this.clientH = document.documentElement.clientHeight || document.body.clientHeight;*/
      /*window.onbeforeunload = function () {// 窗口关闭前储存红点localstorage
        let pushPoint = localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")) : {};
        localStorage.setItem("pushPoint", JSON.stringify(pushPoint));//把红点状态储存到localstorage

      }*/
    },
    mounted(){
      if (!localStorage.getItem("token")) {
        if(this.$route.path !== "/login"){
          this.$router.push('/login')
        }
      }
    },
    components: {
      MainCmp,
    },
    computed: {
      clientH: function () {
        return this.$store.state.clientH;
      },
      isLogin: function () {//先判断是否登录来显示页面

        return sessionStorage.getItem("loginInfo") && JSON.parse(sessionStorage.getItem("loginInfo")).doc;
      }
    },
    methods: {}
  }
</script>
